// スタイル定数 - ダークモード（curriculum-api風）
export const COLORS = {
  // プライマリ（ブルー）
  primary: '#3b82f6',
  primaryDark: '#2563eb',
  primaryLight: '#60a5fa',
  accent: '#34d399',

  // グラデーション
  primaryGradient: 'linear-gradient(90deg, #60a5fa 0%, #34d399 100%)',
  premiumGradient: 'linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)',
  successGradient: 'linear-gradient(90deg, #10b981 0%, #34d399 100%)',
  accentGradient: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',

  // ダーク背景色
  overlay: 'rgba(0, 0, 0, 0.7)',
  white: '#e2e8f0',
  background: '#0a0f1a',
  surface: '#141b2d',
  cardBg: '#141b2d',
  border: 'rgba(255,255,255,0.1)',

  // グレースケール（ダーク用）
  gray50: '#1e293b',
  gray100: '#1e293b',
  gray200: 'rgba(255,255,255,0.1)',
  gray300: 'rgba(255,255,255,0.2)',
  gray400: '#64748b',
  gray500: '#64748b',
  gray600: '#94a3b8',
  gray700: '#cbd5e1',
  gray800: '#e2e8f0',
  gray900: '#ffffff',

  // セマンティック
  success: '#10b981',
  successLight: 'rgba(16, 185, 129, 0.2)',
  error: '#ef4444',
  errorLight: 'rgba(239, 68, 68, 0.2)',
  warning: '#f59e0b',
  warningLight: 'rgba(245, 158, 11, 0.2)',
  info: '#3b82f6',
  infoLight: 'rgba(59, 130, 246, 0.2)',

  // SNSカラー
  twitter: '#e2e8f0',
  threads: '#e2e8f0'
};

export const SPACING = {
  xs: '0.25rem',   // 4px
  sm: '0.5rem',    // 8px
  md: '1rem',      // 16px
  lg: '1.5rem',    // 24px
  xl: '2rem',      // 32px
  xxl: '3rem',     // 48px
  xxxl: '4rem'     // 64px
};

export const BORDER_RADIUS = {
  sm: '4px',
  md: '6px',
  lg: '8px',
  xl: '12px',
  full: '9999px'
};

export const SHADOWS = {
  none: 'none',
  sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
  md: '0 2px 4px rgba(0, 0, 0, 0.06)',
  lg: '0 4px 8px rgba(0, 0, 0, 0.08)',
  xl: '0 8px 16px rgba(0, 0, 0, 0.1)',
  card: '0 1px 3px rgba(0, 0, 0, 0.08)',
  cardHover: '0 4px 12px rgba(0, 0, 0, 0.12)',
  button: '0 2px 4px rgba(0, 0, 0, 0.1)',
  buttonHover: '0 4px 8px rgba(0, 0, 0, 0.15)'
};

export const TRANSITIONS = {
  default: 'all 0.15s ease',
  smooth: 'all 0.2s ease',
  bounce: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
};

export const TYPOGRAPHY = {
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Hiragino Sans", "Noto Sans CJK JP", sans-serif',
  fontSize: {
    xs: '0.75rem',   // 12px
    sm: '0.875rem',  // 14px
    base: '1rem',    // 16px
    lg: '1.125rem',  // 18px
    xl: '1.25rem',   // 20px
    '2xl': '1.5rem', // 24px
    '3xl': '2rem',   // 32px
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },
  lineHeight: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75
  }
};

export const Z_INDEX = {
  base: 0,
  dropdown: 100,
  sticky: 200,
  fixed: 300,
  modalBackdrop: 400,
  modal: 500,
  popover: 600,
  tooltip: 700
};
